//export type ProductTabsType = Record<string, string>;
export interface ProductTabsType<T> {
  [key: string]: T;
}

export const MELCO_PRODUCT_API_SERVICE_TABS = "devices,history";
export const MELCO_PRODUCT_FUSION_TABS = "devices,history,trials";
export const MELCO_PRODUCT_EFS_TABS = "devices,history,trials";
export const MELCO_PRODUCT_MATTERHORN_TABS = "devices,history";
export const MELCO_PRODUCT_ACCOUNT_TABS = "devices,history";
export const MELCO_PRODUCT_CONTROL_CENTER_TABS = "devices,history,permissions";
export const MELCO_PRODUCT_DESIGNSHOP_TABS = "licenses,devices,history,trials";
export const MELCO_PRODUCT_SUMMIT_MANAGER_TABS = "licenses,devices,history";
export const MELCO_PRODUCT_MACHINECLOUD_TABS = "devices,history";

export const BERNINA_PRODUCT_CONTROL_CENTER_TABS =
  "devices,history,permissions";
export const BERNINA_PRODUCT_TOOLBOX_CLOUD_TABS = "devices,history";
export const BERNINA_PRODUCT_TOOLBOX_TABS =
  "licenses,devices,history,logfiles,trials";

export const MASTER = "Master";
export const SUB_USER = "Subuser";
export const ADMIN = "ADMIN";
export const CUSTOM = "CUSTOM";
